import { TGroupedGetAllAvailablePrizesResponse } from '@daymade/api-contracts';
import styles from './PrizeCategoryCarousel.module.css';
import PrizeCardWithTitleBelow from '../PrizeCardWithTitleBelow';
import PrizeCard2026 from '../PrizeCard2026';
import EmblaCarousel from 'components/carousel2025/EmblaCarousel';
import CarouselButtons from 'components/carousel2025/CarouselButtons';
import useEmblaCarousel from 'embla-carousel-react';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { ReactElement, useState } from 'react';
import Link from 'next/link';
import AspectRatioContainer from 'components/about-us/AspectRatioContainer';
import ImageWithFallback from 'components/ImageWithFallback';
import PrizeGroupingHeader from './PrizeGroupingHeader';
import { IPrizeTableEntry } from 'components/how-it-works/prizeTableData';

interface Props {
  /** The title of the group. This is a ReactElement to support strong and em elements in titles */
  categoryTitle: ReactElement | string;
  categorySubtitle: string;
  image: ReactElement;
  prizes: TGroupedGetAllAvailablePrizesResponse[string];
  showPrizeTierBadge: boolean;
  groupingPageHref: string;
  groupingImageSrc: string;
  criteria?: IPrizeTableEntry;
}
const PrizeCategoryCarousel = (props: Props) => {
  const [categoryInfoVisible, setCategoryInfoVisible] = useState(false);
  const emblaCarouselInfo = useEmblaCarousel({
    loop: false,
    duration: 10,
    inViewThreshold: 0.1,
  });

  return (
    <section className={styles.categorySection}>
      <AboutUsSiteContainer>
        <header className={styles.header}>
          <PrizeGroupingHeader {...props} renderAsLink />
        </header>
        <div className={styles.carouselContainer}>
          <EmblaCarousel
            className={styles.carousel}
            emblaCarouselInfo={emblaCarouselInfo}
            hidePips
            items={[
              ...props.prizes.map((x) => (
                <PrizeCard2026
                  prize={x}
                  prizeTitleElementTagName="h2"
                  showPrizeTierBadge={props.showPrizeTierBadge}
                  imageAspectRatio="WIDE"
                />
              )),
              <div className={styles.viewAllCard}>
                <AspectRatioContainer width={319} height={221}>
                  <ImageWithFallback
                    className={styles.viewAllImage}
                    src={props.groupingImageSrc}
                    alt=""
                    layout="fill"
                    objectFit="cover"
                    sizes="(min-width: 768px) 50vw, 100vw"
                  />
                  <Link href={props.groupingPageHref}>
                    <a
                      className={`${styles.fullSizeLink} aboutUsTypographyHeaderMedium`}
                    >
                      <span className={styles.viewAllBadge}>{props.image}</span>
                      <span>
                        View all
                        <br />
                        {props.categoryTitle} prizes
                      </span>
                    </a>
                  </Link>
                </AspectRatioContainer>
              </div>,
            ]}
          >
            <CarouselButtons
              changeSelectedIndex={(x) =>
                x < 0
                  ? emblaCarouselInfo[1]?.scrollPrev()
                  : emblaCarouselInfo[1]?.scrollNext()
              }
            />
          </EmblaCarousel>
        </div>
      </AboutUsSiteContainer>
    </section>
  );
};

export default PrizeCategoryCarousel;
